<template>
  
    <div id="case_studies_wrapper">
        <div v-if="items" id="scroll_listen" ref="case_studies_overflow" class="d-block d-lg-flex overflow-wrapper">
            
            <div v-for="(i, index) in items" :key="i.id" class="d-block d-lg-flex flex-nowrap">
                <!-- spacer -->
                <!-- <div id="spacer" v-if="index == 0" class="vw-100">hi</div> -->
                <!-- case study intro -->
                <CaseStudiesIntro v-if="index == 0" :items="items"></CaseStudiesIntro>
                
            
                <!-- case study details -->
                <CaseStudyDetail 
                    :items="items" 
                    :i="i" 
                    :index="index" 
                    :case_study_section="case_study_section" 
                    @lastPane="isLastPane"></CaseStudyDetail>
            </div>
        </div>

        <div v-if="items" class="side-scroll-nav d-none d-lg-flex" aria-hidden="true">
            <div v-for="(item, index) in scrollNav" :key="index">
                <button class="btn-reset" :id="'side_scroll_' + item.section + '_pane_' + (ind + 1)" v-for="(p, ind) in item.panes" 
                    :key="ind" @click="scrollToPane('#' + item.section + '_pane_' + (ind + 1))" >
                </button>
            </div>
        </div>

        <CtaCircle
            id="downArrow"
            ref="downArrow" 
            :label="$t(iKey('case_study_section','case_study_intro','cta_next'))"
            :appear="lastPane"
            :color="'019c95'"
            @clicked="scrollDown"></CtaCircle>

    </div>
  
</template>

<script>
import { TweenLite } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import { i18nKey } from '@/services/i18n/i18n.js'
import CaseStudiesIntro from '@/components/case_studies/CaseStudiesIntro'
import CaseStudyDetail from '@/components/case_studies/CaseStudyDetail'
import CtaCircle from '@/components/ui/CtaCircle'

ScrollToPlugin; // needed so ScrollToPlugin gets regsitered w webpack.

export default {
    name: 'CaseStudies',
    data: () => {
        return {
            scrollNav: [
                {section: 'intro', panes: new Array(1)},
                {section: 'cs_0', panes: new Array(4)},
                {section: 'cs_1', panes: new Array(4)}
            ],
            lastPane: false
        }
    },
    props: [
        'items',
        'case_study_section'
    ],
    components: {
        CaseStudyDetail,
        CaseStudiesIntro,
        CtaCircle
    },
    computed: {
        computedData(){
            return this.$data.scrollNav
        }
    },
    methods: {
        iKey(section, obj, field){
        return i18nKey(section, obj, field)
        },
        scrollToPane(pane){
            var container = this.$refs.case_studies_overflow
            TweenLite.to(container, 1, {scrollTo: pane})
        },
        scrollDown(){
            TweenLite.to(window, 1, {scrollTo: '#upstanders_you_know'})
        },
        isLastPane(value){
            this.lastPane = value;
        }
    },
    mounted() {
      
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#case_studies_wrapper {
    position: relative;
    z-index: 1;
}
.side-scroll-nav {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
}
.side-scroll-nav button {
    width: 15px;
    height: 15px;
    min-width: 15px;
    min-height: 15px;
    margin: 0 10px 0 10px;
    border-radius: 50%;
    background: #382e2b;
    opacity: 0.5;
    border: 0;
    transition: opacity 0.3s;
}
.side-scroll-nav button.active {
    opacity: 1;
}
.guide-text {
    color: #ed7530;
}
.overflow-wrapper {
    overflow-x: hidden;
    overflow-y: hidden;
    height: auto;
}
@media (min-width: 992px) {
    .overflow-wrapper {
        overflow-x: scroll;
        overflow-y: hidden;
        height: 100vh;
        -webkit-overflow-scrolling: touch;
    }
}
.container-fluid {
    background-color: #efefef;
}


#downArrow {
    position: absolute;
    bottom: -3%;
    right: 10%;
}

</style>
